import React from "react";
import Layout from "../layout/Layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createAdmin } from "../Redux/Action/AuthAction";
import SubAdminForm from "../Component/SubAdminForm";

export default function AddSubAdmin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (value) => {
    return dispatch(createAdmin(value)).then(function () {
      navigate("/sub-admin-management");
    });
  };

  return (
    <Layout>
      <div className="dashboard_data_wrap sub-admin-management">
        <div className="dashbord_cont_wrapper">
          <SubAdminForm onSubmit={handleSubmit} isEdit={false} />
        </div>
      </div>
    </Layout>
  );
}
